import { makeStyles } from "@material-ui/core/styles";

export const HeaderJss = makeStyles((theme) => ({
  appBar: {
    backgroundColor: theme.palette.black.light,
  },
  primaryText: {
    fontWeight: "bolder",
  },
  footerToolbar: {
    alignSelf: "center",
    padding: theme.spacing(3),
  },
  footerTextPrimary: {
    fontSize: 12,
    fontWeight: "bolder",
  },
  footerText: {
    fontSize: 12,
  },
  logoRipleyContainer: {
    backgroundColor: theme.palette.black.light,
    padding: theme.spacing(3),
    '& .MuiSvgIcon-root': {
      width: 30,
      height: "auto",
    }
  },  
}));
